module.exports = __webpack_public_path__ + "img/free07_800x400.0d1dfee3.jpg";